import { useEffect } from "react";
import {
  setDesktopDocument,
  type DesktopDocumentSession,
} from "@/lib/desktop-session";
import { recordRecentDocument } from "@/lib/desktop-recent";
import { resetMainWindowTitle, setMainWindowTitle } from "@/lib/desktop-window";
import { isDesktopApp } from "@/lib/runtime";

/**
 * Tells the Mac shell which document the File menu is talking to.
 *
 * Title and dirty state update the window independently of the menu rebuild,
 * so typing does not reconstruct the menu bar on every keystroke.
 */
export function useDesktopDocument(session: DesktopDocumentSession | null) {
  const documentId = session?.id ?? null;

  useEffect(() => {
    if (!isDesktopApp) return;
    setDesktopDocument(session);
    if (session) {
      recordRecentDocument(session.id, session.title);
      void setMainWindowTitle(session.title, session.dirty);
    } else {
      void resetMainWindowTitle();
    }
  });

  useEffect(() => {
    if (!isDesktopApp) return;
    return () => {
      setDesktopDocument(null);
      void resetMainWindowTitle();
    };
  }, [documentId]);
}
